/** Source: public/design-patterns.html C-6a; data: src/data/faq/*.json. */
import { faq } from '../../data/content'
type Item = { q?: string; a?: string; question?: string; answer?: string }
type Ref = keyof typeof faq
export function Faq({ ref: faqRef, limit, items }: { ref?: Ref; limit?: number; items?: Item[] }) {
  const source: Item[] = items ?? (faqRef ? faq[faqRef].items : [])
  const visible = typeof limit === 'number' ? source.slice(0, limit) : source
  return <div className="shell sec tight"><div className="faq">{visible.map((item, i) => <details open key={`${item.q ?? item.question}-${i}`}><summary><span className="q">Q</span>{item.q ?? item.question}</summary><div className="a"><span className="q">A</span><p>{item.a ?? item.answer}</p></div></details>)}</div></div>
}

